<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-lg-3">
                    <h3 class="my-4">Order Information</h3>
                    <div class="card">
                        <table class="table mb-0 table-borderless">
                            <tbody>
                            <tr>
                                <th>Total</th>
                                <td>Ksh. {{Math.round(details.total_price)}}</td>
                            </tr>

                            <tr v-if="details.coupon_id">
                                <th>Coupon</th>
                                <td><span class="text-success">{{details.coupon.code}}</span></td>
                            </tr>

                            <tr v-if="details.coupon_id">
                                <th>Discount</th>
                                <td>Ksh: {{-Math.round(details.discount)}}</td>
                            </tr>

                            <tr>
                                <th>Sub-Total</th>
                                <td>Ksh: {{Math.round(details.sub_total)}}</td>
                            </tr>

                            <tr>
                                <th>Status</th>
                                <td>
                                    <span v-if="details.status == 'pending'"
                                          style="color: blue;">{{details.status}}</span>
                                    <span v-if="details.status == 'cancelled'"
                                          style="color: red;">{{details.status}}</span>
                                    <span v-if="details.status == 'completed'"
                                          style="color: green;">{{details.status}}</span>
                                    <span v-if="details.status == 'in-transit'"
                                          style="color: yellow;">{{details.status}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <hr>
                        <div class="form-group p-3">
                            <label>Change status</label>
                            <select v-model="details.status" @change="changeStatus($event)" class="form-control">
                                <option value="pending">Pending</option>
                                <option value="in-transit">In-Transit</option>
                                <option value="completed">Completed</option>
                                <option value="cancelled">Cancelled</option>
                            </select>
                        </div>
                    </div>
                    <div class="card mt-4">
                        <div class="card-header">
                            <h5>Customer Info</h5>
                        </div>
                        <div class="table-responsive">
                            <table class="table mb-0 table-borderless">
                                <tbody>
                                <tr>
                                    <th>Name</th>
                                    <td>{{details.customer.name}}</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td>{{details.customer.email}}</td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td>{{details.customer.phone}}</td>
                                </tr>
                                <tr>
                                    <th>County</th>
                                    <td>{{details.customer.county}}</td>
                                </tr>
                                <tr>
                                    <th>Town</th>
                                    <td>{{details.customer.town}}</td>
                                </tr>
                                <tr>
                                    <th>Village</th>
                                    <td>{{details.customer.village}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- /.col-lg-3 -->

                <div class="col-lg-9">

                    <div class="card mt-4">
                        <div class="card-body">
                            <table class="table mb-0">
                                <tbody>
                                <tr>
                                    <th>Order Number</th>
                                    <td>{{details.orderNo}}</td>
                                </tr>

                                <tr>
                                    <th>Payment Status</th>
                                    <td>
                                        <span v-if="details.paid == 1" class="badge badge-success">paid</span>
                                        <span v-if="details.paid == 0" class="badge badge-warning">not paid</span>
                                    </td>
                                </tr>

                                <tr>
                                    <th>Items in order</th>
                                    <td>{{details.items.length}}</td>
                                </tr>

                                <tr>
                                    <th>Phone</th>
                                    <td>{{details.phone}}</td>
                                </tr>

                                <tr>
                                    <th>Delivery</th>
                                    <td>
                                        <span v-if="details.deliver == 'home'">Deliver at my home</span>
                                        <span v-if="details.deliver == 'office'">Pickup at your office</span>
                                    </td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>County</th>
                                    <td>{{details.county}}</td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>Delivery Address</th>
                                    <td>{{details.address}}</td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>Delivery Location Name</th>
                                    <td>{{details.LocationName}}</td>
                                </tr>

                                <tr>
                                    <th>Date</th>
                                    <td>{{moment(details.created_at).format('MMMM Do YYYY, h:mm:ss a')}}</td>
                                </tr>
                                <tr v-if="details.deliver == 'home'  && details.status == 'pending'">
                                    <th>Assign Rider this Delivery</th>
                                    <span v-if="details.status == 'in-transit'"><td>
                                        <button type="button" class="btn btn-primary btn-sm fa fa-edit"  data-toggle="modal" data-target="#addRider" @click="editModal(rider)"> Edit Delivery</button>
                                    </td></span>
                                    <span v-if="details.status == 'pending'"><td><button type="button" class="btn btn-success btn-sm"  data-toggle="modal" data-target="#addRider" @click="newModal">Assign Rider</button></td></span>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- /.card -->

                    <!-- Rider Modal-->
                    <div class="modal fade addRider-modal-lg" tabindex="-1"   id="addRider" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 v-if="!isEdit">Assign Rider</h4>
                                    <h4 v-if="isEdit">Edit User</h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form method="post" @submit.prevent="assignRider">

                                        <div class="form-group">
                                            <label><b>Select a Rider</b><span class="required">*</span></label>
                                            <v-select v-model="formR.rider" label="name" :options="riders"
                                                      :reduce="rider => rider.id" placeholder="Select Rider"></v-select>
                                            <small style="color: red" v-if="error && errors.rider">{{ errors.rider[0]}}</small>
                                        </div>
                                        <hr>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="close">Close</button>
                                            <button type="submit" class="btn btn-success btn-sm" v-if="!isEdit">Assign Rider</button>
                                            <button type="button" class="btn btn-success btn-sm" v-if="isEdit" @click="updateRider">
                                               Update Rider
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="card card-outline-secondary my-4">
                        <div class="card-header">
                            <i class="fas fa-shipping-fast"></i> Shipped By
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col" >Email</th>
                                    <th scope="col">Phone</th>
                                    <th scope="col">County</th>
                                    <th scope="col">Delivery status</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr  v-for="dev in delivery" :key="dev.id" >
                                    <td>
                                        {{dev.rider.name}}
                                    </td>
                                    <td>
                                        {{dev.rider.phone}}
                                    </td>
                                    <td>
                                        {{dev.rider.email}}
                                    </td>
                                    <td>
                                        {{dev.rider.county}}
                                    </td>
                                    <td>
                                        {{dev.status}}
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-primary btn-sm fa fa-edit"  data-toggle="modal" data-target="#addRider" @click="editModal(dev)"> Edit</button>
                                        <!--<a href="#"  data-toggle="modal" type="button" data-target="#addRider" @click="editModal(dev)">
                                            <i class="fa fa-edit text-teal"></i>
                                        </a>-->
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal fade editRider-modal-lg" tabindex="-1"   id="editRider" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">

                                    <h4>Edit Rider</h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form method="post" @submit.prevent="assignRider">

                                        <div class="form-group">
                                            <label><b>Select a Rider</b><span class="required">*</span></label>
                                            <v-select v-model="formR.rider" label="name" :options="riders"
                                                      :reduce="rider => rider.id" placeholder="Select Rider"></v-select>
                                            <small style="color: red" v-if="error && errors.rider">{{ errors.rider[0]}}</small>
                                        </div>
                                        <hr>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="close">Close</button>
                                            <button type="submit" class="btn btn-success btn-sm" v-if="!isEdit">Assign Rider</button>
                                            <button type="button" class="btn btn-success btn-sm" v-if="isEdit" @click="updateRider">
                                                Update Rider
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>

                   <!--Item card-->
                    <!-- <div class="card card-outline-secondary my-4">
                        <div class="card-header">
                            Items in order
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col" width="120">Quantity</th>
                                    <th scope="col" width="120">Price (Ksh)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in details.items" :key="item.id">
                                    <td>
                                        <figure class="media">
                                            <div class="img-wrap"><img :src="item.product.files[0].filePath"
                                                                       class="img-thumbnail img-sm"
                                                                       style="width: 90px;">
                                            </div>
                                            <figcaption class="media-body pl-3">
                                                <h6 class="title text-truncate">{{item.product.title}}</h6>
                                                <dl v-if="item.product.quantity" class="param param-inline small">
                                                    <dt>Quantity:</dt>
                                                    <dd>{{item.product.quantity}}</dd>
                                                </dl>
                                            </figcaption>
                                        </figure>
                                    </td>
                                    <td>
                                        {{item.quantity}}
                                    </td>
                                    <td>
                                        <div class="price-wrap">
                                            <var class="price">{{item.quantity * item.product.price}}</var>
                                            <small class="text-muted">({{Math.round(item.product.price)}} each)</small>
                                        </div> 
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> -->
                    <!-- /.card -->
                    <!--Shipment card-->
                    <div class="card card-outline-secondary my-4"  v-for="ship in shipment" :key="ship.id">
                        <div class="card-header">
                             <div class="row">
                                 <div class="col-md-8">
                                    <h4 class="font-weight-bold text-warning">Order by Shipment</h4>
                                </div>
                            <div class="card-tools col-md-4" v-if="details.deliver == 'home'  && details.status == 'pending'">
                                 <button type="button" class="btn btn-warning btn-sm fas fa-broadcast-tower"  data-toggle="modal" data-target="#addRider" @click="editModal(dev)">BroadCast</button>
                                <button type="button" class="btn btn-success btn-sm fas fa-motorcycle"  data-toggle="modal" data-target="#addRider"  @click="newModal(ship)">Assign Rider</button>
                            </div>
                             </div>
                        </div>
                        <div class="card-body table-responsive">
                            <span>Shop Name</span>
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col" width="120">Quantity</th>
                                    <th scope="col" width="120">Price (Ksh)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr  v-for="shp in ship" :key="shp.id">
                                    <td>
                                       <figure class="media">
                                            <div class="img-wrap"><img :src="shp.product.files[0].filePath"
                                                                       class="img-thumbnail img-sm"
                                                                       style="width: 90px;">
                                            </div>
                                            <figcaption class="media-body pl-3">
                                                <h6 class="title text-truncate">{{shp.product.title}}</h6>
                                                <dl v-if="shp.product.quantity" class="param param-inline small">
                                                    <dt>Quantity:</dt>
                                                    <dd>{{shp.product.quantity}}</dd>
                                                </dl>
                                            </figcaption>
                                        </figure>
                                    </td>
                                    <td>
                                        {{shp.quantity}}
                                    </td>
                                    <td>
                                       <div class="price-wrap">
                                            <var class="price">{{shp.quantity * shp.product.price}}</var>
                                            <small class="text-muted">({{Math.round(shp.product.price)}} each)</small>
                                        </div> <!-- price-wrap .// --> 
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- /.col-lg-9 -->

            </div>
            <div class="row mt-3" v-if="details.deliver == 'home'">
                <h5>Delivery Location in Map</h5>
                <hr>
                <GmapMap
                        :center="{lat:parseFloat(details.latitude), lng:parseFloat(details.longitude)}"
                        :zoom="9"
                        map-type-id="terrain"
                        :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: true,
                   disableDefaultUi: false
                 }"
                        style="width: 100%; height: 500px"
                >
                    <GmapMarker
                            :position="{lat: parseFloat(details.latitude), lng: parseFloat(details.longitude)}"
                            :clickable="true"
                            :draggable="true"
                            @click="center=m.position"
                    />
                </GmapMap>

            </div>

        </div>
    </div>
</template>
<script>
    let moment = require('moment');
    export default {
        name: 'ShoppingOrderInfo',
        components: {},
        data() {
            return {
                moment,
                orderNo: this.$route.params.orderNo,
                details: [],
                shipment:[],
                delivery:[],
                riders: [],
                isEdit: false,
                errors: {},
                error: false,
                form: {
                    status: ''
                },
                formR: {
                    id:'',
                    rider: '',
                    shipping:'',
                }
            }
        },
        methods: {
            changeStatus(event) {
                this.form.status = event.target.value;
                this.$swal.fire({
                    title: 'Mark as ' + this.form.status + '?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, update status!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/admin/shopLocal/change-status/" + this.orderNo, this.form).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Status updated successfully',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            assignRider(){
                this.axios.post("/admin/shopLocal/delivery/" + this.orderNo , this.formR).then(() =>{
                    this.$swal.fire({
                        title: "Delivery",
                        text: "You have successfully assigned Rider the delivery!",
                        icon: 'success',
                    })
                }).catch(()=>{

                })
            },
            getRider(){
                this.axios.get("admin/shopLocal/myRider/" + this.orderNo).then(({data})=>([this.delivery = data]));
            },
            updateRider(){
                this.axios.post("/admin/shopLocal/Rider/"+ this.orderNo, this.formR).then(() =>{

                }).catch(()=>{

                })
            },
            newModal(ship) {
                this.editMode = false;
                this.formR ={
                    rider: '',
                    shipping: '',
                }
                 this.formR.shipping = ship[0].shipment_id;
            },
            editModal(dev){

                this.isEdit = true;
                this.formR =  {
                    rider:''
                },
                this.formR.rider = dev.name;
                this.formR.id = dev.id;
            },
            close() {
                $('#addRider').modal('hide');
            },
            getDetails() {
                this.axios.get('/admin/shopLocal/show-details/' + this.orderNo)
                    .then((response) => {
                        this.details = response.data
                    })
                    .catch(() => {

                    })
            },
            getShipment(){
            this.axios.get('/admin/shopLocal/shipment/' + this.orderNo)
                    .then((response) => {
                        this.shipment = response.data
                    })
                    .catch(() => {

                    })
            },
            loadRider() {
                this.axios.get("/admin/rider").then(({data}) => ([this.riders = data]));
            },
        },
        created() {
            this.getDetails();
            this.loadRider();
            this.getRider();
            this. getShipment();
        }

    };
</script>
<style></style>
